import React from "react";

import { spenmoOrangeLogoLargeWithText } from "assets/v1.1/logo/spenmo";
import "./styles.scss";

export const AuthBoxLogo = (): React.ReactElement => {
  return <img src={spenmoOrangeLogoLargeWithText} alt="Spenmo Logo" id="companyLogo" className="auth-box__logo" />;
};
